import { useCallback } from 'react';
import { RESET_METHODS } from '../data';

const { SMS, EMAIL } = RESET_METHODS;

export default function useResetFormNavigation({
  method,
  email,
  cell,
  setEmail,
  setCell,
  clearFieldError,
  changeMethod,
  classes,
  setCellKey,
}) {
  const handleKeyNavigation = useCallback(
    (e) => {
      const { key, target, ctrlKey, metaKey } = e;
      const id = target?.id;
      const isRadio = id === 'radio-sms' || id === 'radio-email';
      const isInput = id === 'cell' || id === 'email';

      const submitForm = (form) => {
        if (!form) return;
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
          return;
        }
        const btn = form.querySelector(
          'button[type="submit"], input[type="submit"]'
        );
        if (btn) {
          btn.click();
          return;
        }
        form.dispatchEvent(
          new Event('submit', { bubbles: true, cancelable: true })
        );
      };

      if ((key === 'ArrowLeft' || key === 'ArrowRight') && isRadio) {
        e.preventDefault();
        const next = method === SMS ? EMAIL : SMS;
        changeMethod(next, {
          track: true,
          shouldFocus: true,
        });
        return;
      }

      if (isInput && key === 'Enter') {
        e.preventDefault();
        const form = target?.form || target.closest?.('form');
        submitForm(form);
        return;
      }

      const isPrintable = key && key.length === 1;
      const isEditKey =
        isPrintable ||
        key === 'Backspace' ||
        key === 'Delete' ||
        (key === 'v' && (ctrlKey || metaKey));

      if (isEditKey) {
        if (method === SMS && id === 'cell' && email) {
          setEmail('');
          clearFieldError('email');
        } else if (method === EMAIL && id === 'email' && cell) {
          setCell('');
          clearFieldError('cell');
          setCellKey((k) => k + 1);
        }
      }
    },
    [
      method,
      email,
      cell,
      setEmail,
      setCell,
      clearFieldError,
      changeMethod,
      setCellKey,
    ]
  );

  return { handleKeyNavigation };
}
